// app/page.js

"use client"

import React, { useContext, useState } from "react";
import styles from "./page.module.css";
import NavBar from "./components/NavBar/NavBar";
import Banner from "./components/Banner/Banner";
import CoreSolutions from "./components/CoreSolutions/CoreSolutions";
import Performance from "./components/Performance/Performance";
import ContactForm from "./components/ContactForm/ContactForm";
import SlowLoad from "./wrappers/Slowload";
import CTA from "./components/CTA/CTA";
import Footer from "./components/Footer/Footer";
import AboutUs from "./components/AboutUs/AboutUs";
import Toast from "./components/Toast/Toast";
import { motion } from 'framer-motion'
import ScreenContext from "./context/ScreenContext";

export default function HomePage() {
  const [isOpen, setIsOpen] = useState(false);
  const [formOpen, setFormOpen] = useState(false);
  const [message, setMessage] = useState("");

  const links = [
    {
      name: "About Us",
      targetId: "about-us"
    },
    {
      name: "Solutions",
      targetId: "solutions"
    },
    {
      name: "Performance",
      targetId: "performance"
    },
    {
      name: "Contact Us",
      targetId: "contact"
    },
  ]

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: .8, ease: "easeInOut" }}
    >
      <NavBar links={links} setIsOpen={setIsOpen} />
      <div className={styles.page}>
        <div className={styles.container}>
          <div className={styles.inner}>
            <Banner />
            <SlowLoad>
              <CTA />
            </SlowLoad>
          </div>
          <div className={styles.innerAbout}>
              <AboutUs />
          </div>
          <div className={styles.inner}>
            <SlowLoad>
              <CoreSolutions />
            </SlowLoad>
            <SlowLoad>
              <Performance />
            </SlowLoad>
            <SlowLoad>
              <ContactForm setFormOpen={setFormOpen} setMessage={setMessage} />
            </SlowLoad>
          </div>
        </div>
      </div>
      <Toast formOpen={formOpen} setFormOpen={setFormOpen} words={message} />
      <Footer />
    </motion.div >
  );
}
